module.exports = __webpack_public_path__ + "static/screenshot@2x-12eb33cb70277b7db2476a7f0cc1b941.jpg";